import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Link as MuiLink,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import { PropsWithChildren, forwardRef } from 'react'

import { toSafeUrl } from '@karakuri-web/common/utils'
import { IconLayout } from '@karakuri-web/faq-type'

import { QAHeader, QAPanel } from '../components'
import { useFaqRouting } from '../contexts/FaqRoutingContext'
import { values } from '../utils'

interface LinkComponentProps {
  to: string
}
function referenceTo(reference?: string) {
  if (!reference) {
    return ''
  }
  if (reference.indexOf('http') === 0) {
    return reference
  }
  if (reference.indexOf('-') === -1) {
    return `/answer/${reference}/`
  }
  return `/category/${reference}/`
}
interface Props {
  layout: IconLayout
}

/**
 * アイコンウィジェット
 * アイコン形式でカテゴリやFAQへのリンクを表示する
 */
export function IconWidget({ layout }: Props) {
  const { Link: FaqLink } = useFaqRouting()

  function Link({ children, to }: PropsWithChildren<LinkComponentProps>) {
    const internal = /^\/(?!\/)/.test(to)
    if (internal) {
      const LinkWrapper = forwardRef<HTMLAnchorElement>(function LinkWrapper(props, ref) {
        return <FaqLink ref={ref} {...props} to={to} />
      })
      return (
        <MuiLink component={LinkWrapper} color="textSecondary" underline="none">
          {children}
        </MuiLink>
      )
    }
    return (
      <MuiLink
        href={toSafeUrl(to)}
        target="_blank"
        rel="noreferrer"
        color="textSecondary"
        underline="none"
      >
        {children}
      </MuiLink>
    )
  }

  return (
    <QAPanel className="faq-panel-icon">
      <QAHeader title={`${layout.title}`} />
      <div className="faq-panel-card-list">
        {values(layout.icons).map(icon => {
          const reference = icon.reference || ''
          const to = referenceTo(reference)
          return (
            <Card
              key={`${icon.id}`}
              className={clsx('faq-panel-card', { 'faq-panel-noimage': !icon.image })}
            >
              <CardActionArea component="div">
                <Link to={to}>
                  <CardContent className="faq-panel-card-content">
                    <Typography variant="h5">{icon.title}</Typography>
                  </CardContent>
                  {icon.image && (
                    <CardMedia
                      className="faq-panel-card-media"
                      component="img"
                      image={icon.image}
                    />
                  )}
                </Link>
              </CardActionArea>
            </Card>
          )
        })}
      </div>
    </QAPanel>
  )
}
